
import { Component, Vue } from "vue-property-decorator";
import FirmsHeader from "@/components/firms/FirmsHeader.vue";
import FirmsSearch from "@/components/firms/FirmsSearch.vue";
import FirmsEmployee from "@/components/firms/FirmsEmployee.vue";
import FirmsVehicle from "@/components/firms/FirmsVehicle.vue";
import {
  ISolCustomerEmployee,
  ISolCustomerEmployeeResponse,
  ISolCustomerVehicleResponse,
} from "@/services/backend/sol_customer";
import DocumentValidationModal from "@/components/firms/DocumentValidationModal.vue";
import { Getter } from "vuex-class";
import { ICountryConfig } from "@/entities";
import WarningModal from "@/components/common/WarningModal.vue";

@Component({
  name: "firms-page",
  components: {
    DocumentValidationModal,
    FirmsVehicle,
    FirmsEmployee,
    FirmsHeader,
    FirmsSearch,
    WarningModal,
  },
})
export default class FirmsPage extends Vue {
  @Getter("getCountryConfig") countryConfig: ICountryConfig | undefined;

  public solCustomerEmployee: ISolCustomerEmployeeResponse | undefined;
  public firstEmployee: ISolCustomerEmployee | null = null;
  public solCustomerVehicle: ISolCustomerVehicleResponse | undefined;
  public employeeKey = "";
  public vehicleKey = "";
  public showEmployee = false;
  public showVehicle = false;
  public country: string | undefined;
  public searchType: string | undefined;
  public showDocumentValidationModal = false;

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    if (this.countryConfig?.SearchEmployee.ShowWarning) {
      this.$nextTick(() => {
        this.$bvModal.show("warning-modal");
      });
    }
  }

  async asignEmployee(
    response:
      | {
          employee: ISolCustomerEmployeeResponse;
          country: string;
          searchType: string;
        }
      | undefined
  ): Promise<void> {
    if (response && response?.employee?.employees?.length > 0) {
      this.firstEmployee = response.employee.employees[0];
      this.solCustomerEmployee = response.employee;
      this.country = response.country;

      const config = this.countryConfig?.SearchEmployee;

      const hasToValidate =
        this.firstEmployee.validationDocumentType &&
        this.firstEmployee.validationDocumentValue &&
        config?.ApplyValidationDocument &&
        response?.searchType !== "DNI";

      if (hasToValidate) {
        this.showDocumentValidationModal = true;
        this.showEmployee = false;

        this.$nextTick(() => {
          this.$bvModal.show("document-validation-modal");
        });
      } else {
        this.loadDataEmployees();
      }
    } else {
      this.showDocumentValidationModal = false;
      this.solCustomerEmployee = undefined;
      this.firstEmployee = null;
      this.country = undefined;
      this.showEmployee = false;
      this.employeeKey = "";
    }
  }

  loadDataEmployees(): void {
    this.showDocumentValidationModal = false;
    this.showEmployee = true;
    this.showVehicle = false;
    this.employeeKey =
      this.searchType === "workBadge"
        ? this.solCustomerEmployee!.employees[0].workBadge
        : this.solCustomerEmployee!.employees[0].registry;
  }

  async asignVehicle(vehicle: ISolCustomerVehicleResponse | undefined): Promise<void> {
    if (vehicle && Object.keys(vehicle).length > 0) {
      this.solCustomerVehicle = vehicle;
      this.showEmployee = false;
      this.showVehicle = true;
      this.vehicleKey = vehicle.vehicles[0].code;
    } else {
      this.solCustomerVehicle = undefined;
      this.showVehicle = false;
      this.vehicleKey = "";
    }
  }

  async asignType(searchTypeSelected: string): Promise<void> {
    this.searchType = searchTypeSelected;
  }
}
